export default __webpack_public_path__ + "static/media/postjob.15dc78b5.svg";